interface ImagePlaceholderProps {
  readonly className?: string;
}

export function ImagePlaceholder({ className = "" }: ImagePlaceholderProps) {
  return (
      <div className={`relative flex-1 ${className}`}>
      <div className="w-full aspect-square rounded-lg border border-gray-200 dark:border-gray-600 overflow-hidden relative">
        {/* Animated moving gradient background: gray-400 to white to gray-400 */}
        <div className="absolute inset-0 bg-gradient-to-r from-gray-400 via-white to-gray-400 dark:from-gray-800 dark:via-gray-600 dark:to-gray-800 animate-gradient-move"></div>
      </div>
    </div>
  );
}

